import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, GraduationCap } from "lucide-react";
import { BRAND, NAV } from "@/lib/site";

export const Footer = () => {
  return (
    <footer className="mt-20 bg-brand-slate-dark text-brand-cream">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <span className="grid h-11 w-11 place-items-center rounded-2xl bg-brand-sand text-brand-slate-dark">
              <GraduationCap className="h-5 w-5" />
            </span>
            <div>
              <p className="font-heading text-lg font-bold">Joseph Wresinski</p>
              <p className="text-sm text-brand-cream/70">Lycée professionnel privé · {BRAND.ville}</p>
            </div>
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-brand-cream/80">
            Un établissement à taille humaine où chaque jeune est accompagné avec
            bienveillance pour apprendre un métier et construire son avenir
            professionnel.
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-brand-sand">
            Navigation
          </h3>
          <ul className="mt-4 space-y-2 text-sm">
            {NAV.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  data-testid={`footer-nav-${item.to.replace("/", "") || "home"}`}
                  className="text-brand-cream/80 transition-colors hover:text-brand-sand"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-brand-sand">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-brand-cream/80">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-sand" />
              <span>{BRAND.adresse}</span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-sand" />
              <a href={`tel:${BRAND.telephone.replace(/\s/g, "")}`} className="hover:text-brand-sand">
                {BRAND.telephone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-sand" />
              <a href={`mailto:${BRAND.email}`} className="hover:text-brand-sand">
                {BRAND.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-3 px-5 py-6 text-xs text-brand-cream/60 sm:flex-row sm:items-center lg:px-10">
          <p data-testid="footer-copyright">
            © {new Date().getFullYear()} {BRAND.nom}. Tous droits réservés.
          </p>
          <p>Établissement privé sous contrat d'association avec l'État</p>
        </div>
      </div>
    </footer>
  );
};
